import { Alert, Snackbar } from "@mui/material";

export const GraphRAGSnackBar = ({ openKeys, setOpenKeys, navigate }) => {
  return (
    <Snackbar
      open={openKeys}
      autoHideDuration={6000}
      onClose={() => setOpenKeys(false)}
      message={
        "OpenAI keys are required to enable GraphRag options. Please add your keys to proceed."
      }
      action={
        <button
          className="snackbar-button"
          onClick={() => navigate("/dashboard/settingsPage")}
        >
          Add Keys
        </button>
      }
    />
  );
};

export const CreateChatBotSnackBarGeneral = ({
  openAlert,
  setOpenAlert,
  setMessage,
  message,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={openAlert}
      autoHideDuration={6000}
      onClose={() => {
        setOpenAlert(false);
        setTimeout(() => {
          setMessage("");
        }, 1000);
      }}
    >
      <Alert
        variant="standard"
        severity={
          message.startsWith("Error:")
            ? "error"
            : message.startsWith("Info:")
            ? "warning"
            : "success"
        }
      >
        {message.replace("Info:", "")}
      </Alert>
    </Snackbar>
  );
};

export const GenericSnackbar = ({
  open,
  onClose,
  message,
  severity = "info",
  autoHideDuration = 5000,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert onClose={onClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};
